<template>
  <div class="intvTimeIntersect" :style="cssVar">
    <div class="headList" :class="{'visibleHid':!(interviewers && interviewers.length>0)}">
      <div class="head_box">
        <div class="head_item" v-for="(item,index) in interviewers"
             :class="{'hidden':headRankState==='up' && (interviewers.length > headBoxWidth/80 && (index+1+1) > headBoxWidth/80)}">
          <img :src="item.headImg" alt="" :title="item.name + ' ' + item.jobnumber">
          <div class="name" :title="item.name">{{ item.name }}</div>
        </div>
        <div class="head_op" :class="{'hidden':interviewers.length <= headBoxWidth/80}">
          <div v-show="headRankState === 'up'" @click="tabHeadRank('out')">更多</div>
          <div v-show="headRankState === 'out'" @click="tabHeadRank('up')">收起</div>
        </div>
      </div>
    </div>

    <div class="intersectCale" :class="{'visibleHid':!(interviewers && interviewers.length>0)}">
      <div class="cale_nav">
        <div class="before_day" :class="{'unable':new Date(getZeroTime()) >= new Date(getZeroTime(dateValue))}" @click.prevent="tabDay(-1)"><span class="kdfont kdfont-qianfan"></span>{{getLangMsg("intersectIntvTime_beforeDay")}}</div>
        <div class="day_show">
          <div class="date_text">{{ dateValue | formatDate(this_) }}</div>
          <div class="cale_select">
            <el-date-picker
                v-model="dateValue"
                key="date"
                type="date"
                size="small"
                format="yyyy-MM-dd"
                popper-class="intersec_select_date"
                placeholder="选择日期"
                value-format="yyyy/MM/dd"
                :clearable="false"
                :picker-options="pickerOptions"
                @focus="changeColor"
                @change="tabDay(0)"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="after_day" @click="tabDay(1)">{{getLangMsg("intersectIntvTime_afterDay")}}<span class="kdfont kdfont-houfan"></span></div>
      </div>
      <div class="cale_body" v-loading="loading">
        <div class="timeZoneName" :class="{'visibleHid':!(interseTime && interseTime.length>0)}">
          <div>{{getLangMsg("intersectIntvTime_key001")}}</div>
        </div>
        <div class="scroll_content_day" :class="{'visibleHid':!(interseTime && interseTime.length>0)}">
          <div class="date_body_scale">
            <div class="scale_item" v-for="(item,index) in 48"
                 :class="{'invisible':index<16 || index>43,'highLight':haveAbleTimeHours.includes(index)}">
              {{ index % 2 === 1 ? '' : formatScale(item) }}
            </div>
          </div>
          <div class="date_body_content">
            <div class="day_list">
              <div class="hours_list" v-for="(itemHours,indexH) in 48"
                   :class="{'invisible':indexH<16 || indexH>43}"></div>
              <!--面试官时域交集-->
              <div class="intverTimeIntersec_block">
                <div class="intverTimeIntersec_item" v-for="(itemBlock,indexB) in interseTime"
                     :style="{top:calcTop(itemBlock),height:calcHeight(itemBlock)}">
                  <div class="timeRegion">{{ itemBlock.startTime|format_hhmm }} ~ {{
                      itemBlock.endTime|format_hhmm
                    }}
                  </div>
                  <div class="desc">{{getLangMsg("intersectIntvTime_key002")}}</div>
                </div>
              </div>
              <!--面试官时域交集-->
            </div>
            <div class="timeLine" v-show="getZeroTime() === getZeroTime(dateValue)">
              <div class="dot"></div>
            </div>

          </div>
        </div>
        <div class="noAbleTimeTip" v-show="!(interseTime && interseTime.length>0)">
          <img src="images/pc/emotion/hr_nodata_280_160.png?v=1.0" alt="">
          <div class="tip_text">{{getLangMsg("intersectIntvTime_key003")}}</div>
        </div>
      </div>
    </div>

    <div class="noAbleTimeTip" v-show="!(interviewers && interviewers.length>0)">
      <img src="images/pc/emotion/hr_nodata_280_160.png?v=1.0" alt="">
      <div class="tip_text">{{getLangMsg("intersectIntvTime_key004")}}</div>
    </div>
  </div>
</template>

<script>
import {utils} from '../common/common'

export default {
  components: {},
  props: {
    invoke: Function,
    intverIntersectData: Object,
    className:String,
    themeNum:String
  },
  computed: {
    cssVar() {
      return {
        '--color': this.themeNum,
      }
    }
  },
  watch: {
    intverIntersectData: function (value) {
      // this.dateValue = value.dayTime ? value.dayTime : '';
      this.dateValue = value.dayTime ? utils.dateFormat('yyyy/MM/dd',Number(value.dayTime)) : '';
      if (value.interviewers.length !== this.interviewers.length) {
        this.init()
      }
      this.interviewers = value.interviewers ? value.interviewers : [];
      this.haveAbleTimeHours = [];
      if (value.interIntersectionTime && value.interIntersectionTime.length > 0) {
        for (let i in value.interIntersectionTime) {
          if (value.interIntersectionTime[i].timeZone === '北京') {
            let interseTime = value.interIntersectionTime[i].interseTime
            this.interseTime = interseTime ? interseTime : [];
          }
        }
      }
      for (let index in this.interseTime) {
        let startNum = new Date(this.interseTime[index].startTime).getTime();
        let endNum = new Date(this.interseTime[index].endTime).getTime();
        let initNum = this.getZeroTime(this.dateValue);
        let n = 0;
        do {
          let curTimeNum = initNum + n * 3600000
          if (curTimeNum < endNum && curTimeNum >= startNum) {
            this.haveAbleTimeHours.push(n * 2)
          }
          n++;
        } while (n <= 24)
      }
      this.loading = false;
    }
  },
  filters: {
    formatDate(val,this_) {
      if (val) {
        return utils.dateFormat(this_.getLangMsg("intersectIntvTime_key005"),val) + ' ' + this_.weekDateNameList[new Date(val).getDay()]
      }
      return ''
    },
    format_hhmm(time) {
      return utils.dateFormat('hh：mm', time)
    },
  },
  data() {
    return {
      this_:this,
      weekDateNameList: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()) < new Date(new Date().getFullYear() + '/' + (new Date().getMonth()+1) + '/' + new Date().getDate())
        }
      },
      interviewers: [],
      headBoxWidth: 515,
      headRankState: 'up',
      dateValue: '2021/02/02',
      noDataTipImgUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAABhCAMAAAB1chr6AAAAhFBMVEUAAADy9Pn////y9fzy9fny9fry9vv29v/y9fry9frz9vvy8vj////z9vrz9/vy9frz9PTy9frz9vrz9vry9Prz9fvy9vry9fr09vvy9fry9fvy9vvy9fvz9fvz8//x9Pnx9fry9vvv8/f0+f/r6+7y+Pjx9Pnz9vvy9vry9fre4ebq7fLn24UVAAAAKXRSTlMAfARQSFk3HWqMYSYMLj+dFK6llL+D2NBy4rZy8ukVhMjHQC4MJreIwQV8H3oAAAJCSURBVHja7dvdTqtAFIZhZvgp2NIfdeMgbKkWxbrv//52CQK1Ml1ruhJnYtebiDBHT2jynTT1OI7jOO5Msin36IRnr2Zv0D+L0tIIalG6N4LipdahWKl9KFLqABQndQGKkjoBxUjdgCKkjkBhqStQUOoMFJK6AwWkDkEvkNKhH31Gbu9MDGUoQxnKUCehQwxlKEOvBPphGEP75LJ6z8syf08C6TC0LrJyKBcLV6FB9vdLme8kVFb5t5SL0CabKHFvntTDZLFr0Gh76Pmz7dDz1jFovbnX5BjUf2x7e3sc+zyhQ2WQdNtcvUiqU642uqjQhcjLoayoadD0Vtv5eQKh/uk2B7RPfqWNBlX5t4S8RDgPRZKIUNxpI0GTbKLGnLmOEzAKNH6YTJk6Z6L6M1QdGu/HEwq0XeZ+n493OjJ8n0ogokDvNW1qI2iolCqK9q9rfFJDRbEndLLM45Nv9MHHqCjQja6VNIBGN6go0FttqQE0CFFRoCttvsnI46JA77SJbr/nqDeKiwJNwOI1DF2+HFr2DU+nJxRoBe+0mIHQCBcFKhAV4DtN03S3S4eOn3aH+hMKFLPTKoSg89fX+XGaZwo0RjWDBh8XBXqDKgKg66en9aH+2v0/vu+uFGiIKgCgi666XoxNnFGgPi4AKnFRoAGuVkOPAkXsdJt9aITLPhSx0232oeBOd9mHznDZhwI73V/tQ4Gd7u/tQyUu+1AP7mq/uWPoFULLy52l95M1l0Mbjxz9Ry1wZSM9juM4jvsF/Qe1eUljmww3OQAAAABJRU5ErkJggg==",
      interseTime: [],
      haveAbleTimeHours: [],
      timer: null,
      loading: false
    }
  },
  mounted() {
    //赋值周一到周日的多语言文字
    this.weekDateNameList = [
      this.getLangMsg("setIntvTime_week"),
      this.getLangMsg("setIntvTime_mon"),
      this.getLangMsg("setIntvTime_tues"),
      this.getLangMsg("setIntvTime_wednes"),
      this.getLangMsg("setIntvTime_thurs"),
      this.getLangMsg("setIntvTime_fri"),
      this.getLangMsg("setIntvTime_satur")]
    this.init();
  },
  methods: {
    init() {
      // this.headBoxWidth = $(".headList .head_box").width()
      this.$nextTick(()=>{
        //去除滚动条
        this.clearScroll()
        //注册滚动监听
        this.registerScroll()
        //初始化滚动
        this.initTimePosition()
        //初始化时间线
        this.initTimeLine()
      })

    },
    tabHeadRank(val) {
      this.headRankState = val;
      $(".intersectCale .scroll_content_day").scrollTop($(".intersectCale .scroll_content_day").scrollTop() + 1)
    },
    tabDay(num) {
      if(num === -1 && new Date(this.getZeroTime()) >= new Date(this.getZeroTime(this.dateValue))){return;}
      this.loading = true;
      this.dateValue = utils.getNextDate(this.dateValue, num);
      let paramObj = {
        dayTime:new Date(this.dateValue).getTime().toString(),
        interIntersectionTime: [],
        interviewers: this.intverIntersectData.interviewers
      }
      this.invoke("getIntverIntersectData", paramObj)
    },
    initTimeLine() {
      clearInterval(this.timer);
      let timePer = (new Date().getTime() - this.getZeroTime()) / (24 * 60 * 60 * 1000);
      let caleHeight = $("." + this.className + " .intvTimeIntersect .date_body_content").height();
      $("." + this.className + " .intvTimeIntersect .timeLine").css('top', caleHeight * timePer + 'px')
      let this_ = this;
      this.timer = setInterval(function () {
        timePer = (new Date().getTime() - this_.getZeroTime()) / (24 * 60 * 60 * 1000);
        $("." + this_.className + " .intvTimeIntersect .timeLine").css('top', caleHeight * timePer + 'px')
      }, 60000)
    },
    clearScroll() {
      let el = $("." + this.className + " .intersectCale .scroll_content_day")
      let scrollWidth = el[0].offsetWidth - el[0].clientWidth;
      el.css("marginRight", "-" + scrollWidth + "px")
    },
    initTimePosition() {
      let curHourse = new Date().getHours();
      if (curHourse < 13) {
        $("." + this.className + " .intvTimeIntersect .scroll_content_day").animate({scrollTop: 16 * 32 + 'px'}, 500);
      } else {
        $("." + this.className + " .intvTimeIntersect .scroll_content_day").animate({scrollTop: 26 * 32 + 'px'}, 500);
      }
    },
    registerScroll() {
      let el = $("." + this.className + " .intersectCale .scroll_content_day");
      let scrollHeight = 32 * 48;
      let scrollContentHeight = el.height();
      let maxScrollNum = scrollHeight - (scrollContentHeight + 4 * 32) + 15;
      let minScrollNum = 16 * 32;
      let _this = this;
      //注册滚动监听
      el.unbind("scroll");
      el.scroll(function () {
        if (el.scrollTop() < minScrollNum) {
          el.scrollTop(minScrollNum)
        } else if (el.scrollTop() > maxScrollNum) {
          el.scrollTop(maxScrollNum)
        }
      })
    },
    changeColor() {
      this.$nextTick(()=>{
        let eleS = $(".intersec_select_date");
        for (let i = 0, len = eleS.length; i < len; i++) {
          eleS[i].style.setProperty('--color', this.themeNum);
        }
      })
    },
    formatScale(num) {
      num = num - 1;
      let int = parseInt(num / 2);
      let remain = num % 2;
      if (int < 10) {
        int = "0" + int;
      }
      if (remain > 0) {
        return int + ":30";
      } else {
        return int + ":00";
      }
    },
    calcTop(timeObj) {
      let timePer = (new Date(timeObj.startTime).getTime() - this.getZeroTime(timeObj.startTime)) / (24 * 60 * 60 * 1000);
      let caleHeight = $("." + this.className + " .intvTimeIntersect .day_list").height();
      return caleHeight * timePer + 'px';
    },
    calcHeight(timeObj) {
      let timePer = (new Date(timeObj.endTime).getTime() - new Date(timeObj.startTime).getTime()) / (24 * 60 * 60 * 1000);
      let caleHeight = $("." + this.className + " .intvTimeIntersect .day_list").height();
      return caleHeight * timePer + 'px';
    },
  }
}
</script>
<style lang="less">
.intvTimeIntersect {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
  flex-shrink: 1;
  //width: 545px;
  background: #FFFFFF;
  position: relative;

  .visibleHid {
    visibility: hidden;
  }

  .headList {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-size: 12px;
    padding: 24px 10px 0 20px;
    flex-grow: 0;
    flex-shrink: 0;

    .head_box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      flex-shrink: 0;
      flex-grow: 0;
      height: 99px;
      overflow-y: auto;

      .head_item, .head_op {
        width: 80px;
        height: 99px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 24px;
      }

      .head_item {

        img {
          height: 50px;
          width: 50px;
          border-radius: 50%;
        }

        .name {
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 45px;
          text-align: center;
        }
      }

      .head_op {

        div {
          height: 50px;
          width: 50px;
          border-radius: 50%;
          line-height: 50px;
          text-align: center;
          color: #5582F3;
          color: var(--theme-color);
          cursor: pointer;
        }
      }

      .hidden {
        display: none;
      }
    }
  }

  .intersectCale {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    font-size: 12px;
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;

    .cale_nav {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      padding: 0 11px;
      background: #FAFAFA;
      .unable {
        cursor: not-allowed !important;
      }
      .before_day, .after_day {
        color: #999999;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        .kdfont-qianfan {
          margin-right: 4px;
        }

        .kdfont-houfan {
          margin-left: 4px;
        }

      }

      .day_show {
        display: flex;
        flex-direction: row;
        align-items: center;

        .date_text {
          font-size: 14px;
          color: #212121;
        }

        .cale_select {
          margin-left: -28px;
          width: 36px;

          .el-date-editor {
            width: 0;

            input {
              border: 0;
              padding: 0;
              margin: 0;
              background: none;
              width: 0;

            }

            .el-input__prefix {
              left: 30px;
            }

            .el-icon-date {
              font-family: kdfont !important;
              font-size: 16px;
              color: #5582F3;
              color: var(--theme-color);
              cursor: pointer;

              &::before {
                content: "\e648";
              }
            }
          }
        }
      }
    }

    .cale_body {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      flex-grow: 1;
      flex-shrink: 1;
      height: 100px;
      margin: 0 20px;
      overflow-x: hidden;
      position: relative;

      .invisible {
        //visibility: hidden;
      }

      .timeZoneName {
        color: #999999;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-grow: 0;
        flex-shrink: 0;
        height: 42px;

        div {
          width: 55px;
        }
      }

      .scroll_content_day {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        flex-shrink: 1;
        overflow-y: scroll;
        align-items: start;
      }

      .date_body_scale {
        width: 55px;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: stretch;

        .highLight {
          color: #5582F3;
          color: var(--theme-color);
        }

        .scale_item {
          flex-shrink: 0;
          height: 30px;
          margin-bottom: 2px;
          text-align: left;
        }
      }

      .date_body_content {
        position: relative;
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        flex-shrink: 1;

        .day_list {
          width: 100px;
          display: flex;
          position: relative;
          flex-direction: column;
          flex-grow: 1;
          flex-shrink: 1;

          .hours_list {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            flex-shrink: 0;
            height: 30px;
            margin-bottom: 2px;
            background: #F8F8F8;


          }

          .intverTimeIntersec_block {
            position: absolute;
            width: calc(100% - 2px);
            top: 0;
            left: 0;

            .intverTimeIntersec_item {
              position: absolute;
              width: 100%;
              left: 0;
              background: #F2F9FF;
              text-align: center;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: center;
              color: #5582F3;
              color: var(--theme-color);
              font-size: 14px;
              border-left: 3px solid #5582F3;
              border-left: 3px solid var(--theme-color);

              .timeRegion {
                margin-right: 10px;
              }
            }
          }
        }

        .timeLine {
          width: calc(100% - 2px);
          height: 2px;
          background: #FF736C;
          position: absolute;
          display: flex;
          justify-content: start;
          align-items: center;
          left: 0;
          top: 0;

          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #FF736C;
            margin-left: -6px;
          }
        }
      }
    }

  }

  .noAbleTimeTip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 100%;
    height: 100%;


    img {
      margin: 0;
    }

    .tip_text {
      font-size: 14px;
      color: #999999;
    }
  }
}

.intersec_select_date{
  .el-icon-d-arrow-left {
    font-family: kdfont !important;

    &::before {
      content: "\e710";
    }
  }

  .el-icon-arrow-left {
    font-family: kdfont !important;

    &::before {
      content: "\e89e";
    }
  }

  .el-icon-arrow-right {
    font-family: kdfont !important;

    &::before {
      content: "\e89d";
    }
  }

  .el-icon-d-arrow-right {
    font-family: kdfont !important;

    &::before {
      content: "\e704";
    }
  }


  .el-picker-panel__content {
    .el-date-table {
      .el-date-table__row {
        .available {
          &:hover {
            color: #5582F3;
            color: var(--theme-color);
          }
        }

        .today span {
          color: #5582F3;
          color: var(--theme-color);
        }

        .current span {
          color: #FFFFFF;
          background-color: #5582F3;
          background-color: var(--theme-color);
        }
      }
    }

    .el-month-table, .el-year-table {
      .disabled .cell{
        color: #C0C4CC !important;
      }
      .cell {
        &:hover {
          color: #5582F3;
          color: var(--theme-color);
        }
      }

      .current .cell {
        color: #5582F3;
        color: var(--theme-color);
      }

      .today .cell {
        color: #5582F3;
        color: var(--theme-color);
      }
    }
  }

  .el-date-picker__header {
    .el-picker-panel__icon-btn, .el-date-picker__header-label {
      &:hover {
        color: #5582F3;
        color: var(--theme-color);
      }
    }
  }

}
</style>